import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_SRC =
  'https://media.base44.com/images/public/6a68984e1435c2ee512e6e95/c9dcee263_image.png';

export default function Logo({ className = 'h-7 lg:h-8', to = '/' }) {
  return (
    <Link to={to} className="inline-flex items-center shrink-0">
      <img
        src={LOGO_SRC}
        alt="Ahana.Digital"
        width="1024"
        height="293"
        className={`w-auto ${className}`}
      />
    </Link>
  );
}